import { IDiscounts } from '../_types';
import { request } from './http-client';
import { TParams, INewDiscountParams, IDiscountWithAll } from './types';
import { IDiscountWithProducts } from './types/discounts';

const discountService = {
  all: (params: INewDiscountParams, shipperId?: string) =>
    request.get<IDiscountWithAll>('/v2/discount-with-all', {
      params,
      headers: shipperId ? { Shipper: shipperId } : undefined,
    }),
  getDiscountWithOrderPrice: (params: TParams) =>
    request.get<IDiscounts>('/v3/discount-with-order-price', {
      params,
    }),
  discountWithProductsRequest: (params: TParams) =>
    request.get<IDiscountWithProducts>('/v2/discount-with-products', {
      params,
    }),
};

export default discountService;
